module.exports = __webpack_public_path__ + "img/Weapon_207.d99fe9d6.png";